import gsap from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';

gsap.registerPlugin( Draggable, ScrollTrigger, DrawSVGPlugin );

const tmlSlider = () => {
    const slides = document.querySelectorAll( '.wp-block-drsblocks-tml' )
    if ( !slides.length ) return

    init()
    if ( slides.length < 2 ) return
    const slidesArr = [ ...slides ],
        innerHolds = document.querySelectorAll( '.wp-block-drsblocks-tml__holder' ),
        inners = document.querySelectorAll( '.wp-block-drsblocks-tml__inner' )

    let moveSlideTL = gsap.timeline( { paused: true } ),
        nextLoop

    const nextSlide = () => {
        if ( moveSlideTL.isActive() ) return
        const slideFrom = document.querySelector( '.wp-block-drsblocks-tml.active' ),
            innerFrom = slideFrom.querySelector( '.wp-block-drsblocks-tml__inner' ),
            innerHoldFrom = slideFrom.querySelector( '.wp-block-drsblocks-tml__holder' )
        let sectionToIndex = slidesArr.indexOf( slideFrom ) + 1
        if ( sectionToIndex === slides.length ) {
            sectionToIndex = 0
        }
        const slideTo = slides[ sectionToIndex ],
            innerTo = inners[ sectionToIndex ],
            innerHoldTo = innerHolds[ sectionToIndex ]

        moveSlide( slideFrom, slideTo, innerFrom, innerTo, innerHoldFrom, innerHoldTo )

    }

    function moveSlide ( slideFrom, slideTo, innerFrom, innerTo, innerHoldFrom, innerHoldTo ) {
        moveSlideTL = gsap.timeline( { defaults: { ease: "power3.inOut" } } )

        nextLoop.kill()
        // Start it again
        looper()

        moveSlideTL
            .to( innerFrom, { duration: 1.5, xPercent: 100 } )
            .to( innerHoldFrom, { duration: 1.5, xPercent: -100 }, "<" )

            .set( slideTo, { autoAlpha: 1, className: "wp-block-drsblocks-tml active" }, "<" )
            .set( slideFrom, { className: "wp-block-drsblocks-tml" }, "<" )

            .fromTo( innerHoldTo, { xPercent: 100 },
                { duration: 1.5, xPercent: 0 }, "<.5" )
            .set( innerHoldTo, { autoAlpha: 1 }, "<" )
            .fromTo( innerTo, { xPercent: -100 },
                { duration: 1.5, xPercent: 0 }, "<" )
            .set( slideFrom, { clearProps: "all" } )
    }

    function looper () {
        nextLoop = gsap.delayedCall( 6.5, function () {
            nextSlide()
        } )
    }

    looper()

    function init () {
        let highestEl = 0
        const activeSlide = slides[ 0 ],
            mainInner = document.querySelector( '.wp-block-drsblocks-tmls__inner' ),
            activeHolder = activeSlide.querySelector( '.wp-block-drsblocks-tml__holder' )
        gsap.set( activeSlide, { autoAlpha: 1, className: "wp-block-drsblocks-tml active" } )
        gsap.set( activeHolder, { autoAlpha: 1 } )

        slides.forEach( ( item ) => {
            const itemHeight = item.querySelector( '.wp-block-drsblocks-tml__holder' ).offsetHeight
            if ( itemHeight > highestEl ) {
                highestEl = itemHeight
            }
        } )

        mainInner.style.height = highestEl + 'px'
    }
}

window.addEventListener( 'load', () => {
    tmlSlider()
} )